import Drawer from "components/Drawer/index";
// import InputPassword from "components/InputPassword/index";
import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";
import React, { useState } from "react";

import "./authenticationModal.scss";
import Button from "components/Button/index";
import PasswordPin from "components/PasswordPin/index";

const AuthenticationOtp = ({
  handleCancelModel,
  handleCancel,
  setVerifyPassword,
  handleSave,
  width,
  pinRequired = true,
  title = "Enter TOTP",
}) => {

  

  const isMobile = useScreenMobile({ size: 992 });
  return isMobile ? (
    <Drawer isVisible={true} handleCancel={handleCancel} showFooter={false}>
      <Authentication
        handleCancel={handleCancelModel}
        setVerifyPassword={setVerifyPassword}
        handleSave={handleSave}
        pinRequired={pinRequired}
        title={title}
        width={width}
      />
    </Drawer>
  ) : (
    <Modal
      handleCancel={handleCancel}
      showFooter={false}
      customClass={true}
      showCross={false}
      showHeader={false}
    >
      <Authentication
        handleCancel={handleCancelModel}
        setVerifyPassword={setVerifyPassword}
        handleSave={handleSave}
        pinRequired={pinRequired}
        title={title}
        width={width}
      />
    </Modal>
  );
};

export default AuthenticationOtp;

const Authentication = ({
  handleCancel,
  setVerifyPassword,
  handleSave,
  pinRequired,
  title,
  width
}) => {
  const [currentPassword, setCurrentPassword] = useState({
    password: "",
    pin: ""
  });
  const [hasError, setHasError] = useState(false);

  const handleChangePin = (otp) => {
    setCurrentPassword((prev) => ({
      ...prev,
      pin: otp
    }));
    setHasError(false); // Reset error when the user types
  };
  const [loading, setLoading] = useState(false);  

  const handleVerify = async () => {
    // Check if OTP is complete (6 digits)
    if (!currentPassword.pin || currentPassword.pin.length !== 6) {
      setHasError(true);
      return;
    }

    try {
      setLoading(true);
      setHasError(false);
      await handleSave(currentPassword.pin);
    } catch (error) {
      console.error("Error during OTP submit:", error);
      setHasError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container otpContainer">
      <div className="headerBox">
        <p className="title">{title}</p>
        {/* <p className="desc" style={{ width: width }}>
          After scanning the QR code, the app will display a six digit code that
          you can enter below
        </p> */}
      </div>
      <div className="footerBox">
        <div style={{ width: "100%" }}>
          <PasswordPin
            otp={currentPassword.pin}
            setOtp={handleChangePin}
            error={hasError}
            onEnter={handleVerify}
          />
          {hasError && (
            <p
              className="passwordLabel errorPassword"
              style={{ marginTop: "10px", color: "red" }}
            >
              Please enter a valid code
            </p>
          )}
        </div>
        <Button 
          loading={loading} 
          type="violet" 
          title="Verify Code" 
          onClick={handleVerify}
          disabled={!currentPassword.pin || currentPassword.pin.length !== 6}
        />
      </div>
    </section>
  );
};
